export const faqDefault = [
  {
    title: 'O que fazer em caso de erro no pagamento?',
    description:
      'As bandeiras ou os bancos podem gerar conflito durante uma transação, mas não se preocupe. Tente outros cartões, de preferência dos bancos mais frequentes como Banco do Brasil, Bradesco, Santander, Itaú, Nubank e etc.',
  },
  {
    title: 'Não tenho outro cartão. O que fazer?',
    description:
      'Para sua segurança, existe um limite de tentativas de pagamento com um único cartão por link. Se você atingir esse limite e não tiver outro cartão para concluir a compra, sugerimos que peça um novo link ou tente amanhã.',
  },
  {
    title: 'Posso pagar com cartão corporativo?',
    description:
      'Este link de pagamento conta com um sistema de segurança rigoroso, por isso cartões corporativos não são aceitos. ',
  },
];

export const faqCard = [
  {
    title: 'O que fazer em caso de erro no pagamento?',
    description:
      'As bandeiras ou os bancos podem gerar conflito durante uma transação, mas não se preocupe. Tente outros cartões, de preferência dos bancos mais frequentes como Banco do Brasil, Bradesco, Santander, Itaú, Nubank e etc.',
  },
  {
    title: 'Posso pagar com cartão corporativo?',
    description:
      'Este link de pagamento conta com um sistema de segurança rigoroso, por isso cartões corporativos não são aceitos. ',
  },
];
